export default __webpack_public_path__ + "static/media/g-suite.ab5ea1de.svg";